import { Component, OnInit } from "@angular/core";
import { SystemService } from "src/app/service/system.service";

@Component({
  selector: "app-page-not-found",
  templateUrl: "./page-not-found.component.html",
  styleUrls: ["./page-not-found.component.css"],
})
export class PageNotFoundComponent  implements OnInit{
  runMode = "";
  
  constructor(
    public systemService: SystemService,
  ) {}

  ngOnInit() {
    this.systemService.getRunMode().subscribe((data) => {
      this.systemService.runMode = data;
      this.runMode = data;
      if (data === "SITE") {
        this.systemService.runModeDisplay = "e-ISuite Site";
      } else {
        this.systemService.runModeDisplay = "e-ISuite Enterprise";
      }
    });

  }

}


